import signalr from '../plugins/signalr'
import store from './index'

export default {
    namespaced: true,
    state: {
        connection: null,
    },
    getters: {
        GET_CONNECTION: state => {
            return state.connection
        },
    },
    mutations: {
        SET_CONNECTION: (state, payload) => {
            state.connection = new signalr.HubConnectionBuilder()
                .withUrl(payload.url, {
                    accessTokenFactory: () => payload.token,
                    withCredentials: false
                }).build();

            state.connection.start()
        },
    },
    actions: {
        CONNECT({ commit }, payload) {
            let loginInfoObj = store.getters['account/GET_LOGIN_INFO'];
            let isAuthorized = loginInfoObj != null ? true : false;
            if (isAuthorized) {
                let token = loginInfoObj.data.token;
                commit('SET_CONNECTION', { token: token, url: payload });
            }
        }
    }
}
